<div *ngIf="suggestions.length >= 1; else noSuggestion" class="se-ui-default-text-overlay__expander-resize"
     [ngClass]="{'se-ui-default-text-overlay__expander-resize-big': suggestions.length > 1}">
    <div class="se-ui-default-text-overlay__expander">
        <div class="se-ui-default-text__background">
            <div class="se-ui-default-text" (keydown.esc)="onClose()">
                <div style="width: 100%; height: 100%;">
                    <div class="expander-view__size">
                        <!-- SELECT BY ACCORDION -->
                        <mat-accordion class="headers-align" #accordion="matAccordion" *ngIf="!_editingView && !_addingNewText">
                            <mat-expansion-panel *ngFor="let suggestion of suggestions; index as i; last as lastSuggestion"
                                                 #expansionPanel
                                                 class="se-ui-default-text-option__expander"
                                                 [ngClass]="{'se-ui-default-text-option-preselected' : suggestion.id === preSelectedSuggestion.id,
                                      'se-ui-default-text-option__expander-open': _showEditOrDeleteButton && (suggestion.id === _currentSelection.id)}"
                                                 [id]="'suggestion-div-' + i"
                                                 (opened)="_openedAccordion(suggestion, i)"
                                                 (closed)="_closedAccordion()"
                                                 hideToggle
                                                 >
                                <mat-expansion-panel-header class="mat-expansion-panel-header">
                                    <mat-panel-title
                                        (click)="expPanelToggle($event, i, suggestion)"
                                        (dblclick)="selPanelDoubleClikc(suggestion, $event)"
                                        class="mat-expansion-panel-header"
                                        [ngClass]="{'mat-expansion-panel-header-title__expanded': _showEditOrDeleteButton,
                                                    'se-ui-default-text-option__expander-open': _showEditOrDeleteButton && (suggestion.id === _currentSelection.id)}"
                                        matTooltip="{{'Open' | translate}}"
                                        >
                                        <div class="mat-expansion-panel-headertitle_content" [innerHtml]="createSuggestionHTMLExpanderView(suggestion, i+1)"></div>
                                    </mat-panel-title>
                                    <button class="mat-button" mat-button matTooltip="{{'Add' | translate}}"
                                            atTooltipPosition="left"
                                            (click)="onSelectExpander(suggestion, $event)">
                                        <mat-icon class="mat-icon" aria-hidden="false">add</mat-icon>
                                    </button>
                                </mat-expansion-panel-header>

                                <div *ngFor="let item of suggestion.Sentence | keyvalue"
                                     disabled
                                     (keydown.enter)="onSelectExpander(suggestion, $event)"
                                     (click)="onSelectExpander(suggestion, $event)">
                                    <b>{{item.key}}</b>: <div class="se-ui-default-text_sentence" [innerHtml]="item.value"></div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>

                        <!-- EDITING -->
                        <div *ngIf="_editingView || _addingNewText" class="se-ui-default-text-editor_container">

                            <div class="col-6 textarea-style_label se-ui-default-input_container">
                                <div class="col-auto">{{'Code' | translate}}:</div>

                                <input matInput type="text"
                                       class="col-auto new-suggestion__header"
                                       placeholder="{{'DeafultText_InsertCode' | translate}}"
                                       [(ngModel)]="_selectedSuggestion.code">
                            </div>

                            <div class="col-6 textarea-style_label se-ui-default-input_container">
                                <div class="col-auto">{{'Description' | translate}}:</div>
                                <input matInput type="text"
                                       class="col-auto new-suggestion__header"
                                       placeholder="{{'DeafultText_InsertDescription' | translate}}"
                                       [(ngModel)]="_selectedSuggestion.Description">
                            </div>

                            <div class="se-ui-default-input_container se-ui-default-input_text-editor col-24" *ngFor="let item of _selectedSuggestion.Sentence | keyvalue">
                                <div class="col-24 textarea-style_label">{{item.key}}:</div>

                                <se-text-editor class="se-text-editor"
                                                name="se-text-editor"
                                                [(ngModel)]="item.value"
                                                [disabled]="false"
                                                [visible]="true"
                                                [menuConfig]="_predefinedMenuConfiguration"
                                                [shortcutList]="_shortcutList">
                                    <ng-content extra-buttons-before select="[extra-buttons-before]"></ng-content>
                                </se-text-editor>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="expander-view__footer">
        <mat-action-row [ngClass]="{'expander-view__footer-add': !_addingNewText && !_editingView}" class="expander-view__footer-edit">

            <mat-slide-toggle #suggestionPolicySlider (change)="_onSuggestionPolicyChange($event)"
                              [checked]="true"
                              class="suggestion-policy-slider"
                              [matTooltip]="(_suggestionPolicyToggleChecked ? 'SuggestionPolicyToggleTooltip2' : 'SuggestionPolicyToggleTooltip1') | translate"
                              matTooltipPosition="right">
            </mat-slide-toggle>

            <div *ngIf="!(_editingView || _addingNewText)">
                <button class="se-ui-default-text-option__expander-button"
                        mat-button matTooltip="{{'Modify' | translate}}"
                        [disabled]="!_showEditOrDeleteButton"
                        (click)="_onEditClick()">
                    <mat-icon aria-hidden="false">edit</mat-icon>
                </button>
                <button class="se-ui-default-text-option__expander-button se-ui-default-text-option__expander-button-last" mat-button matTooltip="{{'Delete' | translate}}"
                        [disabled]="!_showEditOrDeleteButton"
                        (click)="_onDeleteClick()">
                    <mat-icon aria-hidden="false">delete_outlined</mat-icon>
                </button>
            </div>
            <div class="expander-view__footer-ok" *ngIf="_editingView || _addingNewText">
                <button class="se-ui-default-text-option__expander-button" mat-button matTooltip="{{'Cancel' | translate}}"
                        (click)="_undoFunction()">
                    <mat-icon aria-hidden="false">arrow_back</mat-icon>
                </button>
                <button class="se-ui-default-text-option__expander-button se-ui-default-text-option__expander-button-last" mat-button matTooltip="{{'OK' | translate}}"
                        [disabled]="_isOkButtonDisabled()"
                        (click)="_okFunction()">
                    <mat-icon aria-hidden="false">check</mat-icon>
                </button>
            </div>

        </mat-action-row>
    </div>
</div>
<ng-template #noSuggestion>
    <div class="se-ui-default-text__no-suggestion">
        <span style="margin:10px 0 10px 0;">{{'NoResults' | translate}}</span>
    </div>
</ng-template>
